import { forwardRef, useId, type TextareaHTMLAttributes } from "react";
import { cn } from "../../utils/cn";
import { Field, fieldStateClass } from "./Field";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  helper?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, helper, error, className, id, required, rows = 3, ...rest },
  ref
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <Field label={label} htmlFor={inputId} helper={helper} error={error} required={required}>
      <textarea
        ref={ref}
        id={inputId}
        rows={rows}
        className={cn(fieldStateClass(error, className), "py-2 leading-relaxed resize-y")}
        aria-invalid={Boolean(error)}
        {...rest}
      />
    </Field>
  );
});